import { DeviceErrorType, DeviceModel } from '@shure/shared/angular/data-access/system-api/models';

import { DefaultCdmDeviceBehaviorPlugin } from './default-cdm.device-behavior';

export class ImxComputeZoomCdmDeviceBehaviorPlugin extends DefaultCdmDeviceBehaviorPlugin {
	public override readonly models: DeviceModel[] = [DeviceModel.IMXCOMPUTEZOOM];

	public hideLicenseInfo(_model: DeviceModel): boolean {
		return true;
	}

	public potentialErrorsToSuppress(_model: DeviceModel): DeviceErrorType[] {
		return [DeviceErrorType.LicenseError, DeviceErrorType.LicenseWarning];
	}
}
